import type { HolderType, LedgerType, TaskKind } from '../data/types';

export const LEDGER_LABELS: Record<LedgerType, string> = {
  ISSUE: 'Units issued',
  CALL_PAYMENT: 'Call payment',
  DISTRIBUTION: 'Distribution',
  DRP_ISSUE: 'DRP reinvestment',
  WITHHOLDING: 'Tax withheld',
  REDEMPTION: 'Redemption',
  CAPITAL_RETURN: 'Capital return',
  TRANSFER_IN: 'Transfer in',
  TRANSFER_OUT: 'Transfer out',
  MIGRATION_OPENING: 'Opening balance (migrated)',
  ADJUSTMENT: 'Reversal',
};

export const HOLDER_TYPE_LABELS: Record<HolderType, string> = {
  INDIVIDUAL: 'Individual',
  COMPANY: 'Company',
  TRUST: 'Trust',
  SMSF: 'SMSF',
  PARTNERSHIP: 'Partnership',
};

export const TASK_LABELS: Record<TaskKind, string> = {
  PAY_CALL: 'Payment',
  QUOTE_TFN: 'Tax',
  RENEW_WHOLESALE: 'Eligibility',
  REFRESH_KYC: 'Identity',
  SIGN_DOCUMENT: 'Application',
  CONFIRM_BANK: 'Bank details',
  TAX_RESIDENCY: 'Tax',
  COMPLETE_APPLICATION: 'Application',
};

export const BASIS_LABELS = {
  FIXED_UNITS: '$1.00 fixed units',
  NAV_UNITS: 'NAV-priced units',
  COMMITMENT: 'Commitment / capital calls',
} as const;

export const KYC_TYPE_LABELS: Record<string, string> = {
  PEP_MATCH: 'PEP match',
  SANCTIONS_POTENTIAL: 'Sanctions potential match',
  ID_MISMATCH: 'ID data mismatch',
  DOCUMENT_EXPIRED: 'Document expired',
  WHOLESALE_EXPIRING: 'Wholesale certificate expiring',
  PERIODIC_REFRESH: 'Periodic refresh due',
  ADVERSE_MEDIA: 'Adverse media',
  UBO_INCOMPLETE: 'Beneficial owner unverified',
};

export const CHANGE_LABELS: Record<string, string> = {
  TRANSFER: 'Unit transfer',
  BANK_CHANGE: 'Bank account change',
  ADDRESS_CHANGE: 'Address change',
  REDEMPTION: 'Redemption request',
  TRANSMISSION: 'Transmission (deceased estate)',
  DRP_ELECTION: 'DRP election',
};

export const APPROVAL_LABELS: Record<string, string> = {
  DISTRIBUTION: 'Distribution',
  CAPITAL_CALL: 'Capital call',
  UNIT_ISSUE: 'Unit issue',
  TRANSFER: 'Transfer',
  BANK_CHANGE: 'Bank change',
  REDEMPTION: 'Redemption',
  ADJUSTMENT: 'Ledger reversal',
  MIGRATION: 'Migration',
  CAPITAL_RETURN: 'Capital return',
  REDEMPTION_RUN: 'Redemption run',
  CALL_DEFAULT: 'Call default remedy',
  ISSUE_RUN: 'Financial close unit issue',
  INVESTOR_REPORT: 'Quarterly investor report',
  OFFER_PUBLISH: 'Publish offer',
};
